@mixin user-agent-override {

    &:focus,
    & *:focus {
        outline: none;
    }
}

@mixin default-control-render {
    [data-gx-le-default-render] {
        white-space: nowrap;
    }
}

@mixin empty-outermost-container {
    &>[data-gx-le-container-empty="true"] {
        min-height: var(--gx-le-empty-min-height, 100vh);
    }
}

@mixin containers-defaults {
    [data-gx-le-container] {
        min-height: var(--gx-le-table-min-height);

        &[data-gx-le-container-empty="true"] {
            grid-template-rows: 1fr !important;
        }

        &[data-gx-le-highlighted-container] {
            position: relative;
        }
    }

    &>[data-gx-le-container]:hover:after {
        display: none;
    }
}

gx-control-main-container {
    display: block;
    position: relative;
    //min-height: 100vh;
    padding: 1px;
    // background-color: var(--color-background);
        
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol";

    --gx-le-table-min-height: 24px;
    --gx-le-table-cell-min-height: 24px;

    --gx-le-table-placeholder-width: 8px;
    --gx-le-table-placeholder-height: 8px;
    --gx-le-table-placeholder-color: #234783;

    @include user-agent-override();
    @include empty-outermost-container();
    @include containers-defaults();
    @include default-control-render();
}